import React from 'react';

import NavigationMenu from './components/NavigationMenu';
import AccountMenu from './components/AccountMenu';
import NavigationWrapper from './components/NavigationWrapper';
import MenuWrapper from './components/MenuWrapper';

import Logo from './logo.png';

import styles from './styles.scss';

function NavigationBar() {
  return (
    <NavigationWrapper>
      <img className={styles.logo} src={Logo} alt="arlook" />
      <MenuWrapper>
        <NavigationMenu />
      </MenuWrapper>
      <AccountMenu />
    </NavigationWrapper>
  );
}

export default NavigationBar;



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/index.js